export const SectionItem = (props) => {
  return (
    <section className="section-essentials-brk">
      <h1>{props.category.title}</h1>
      <p>{props.category.description}</p>
      <div className="product-grid-essentials">
        {props.products.map((product, index) => {
          return (
            <div className="card-essentials-brk" key={index}>
              <img src={product.image_product} alt={product.title} />
              <h1>{product.title}</h1>
              <p>{product.description}</p>
              <div className="color-essentials">
                {product.colors.map((color, index) => {
                  return (
                    <div
                      className="color-indiviual"
                      style={{ backgroundColor: color }}
                      key={index}
                    ></div>
                  );
                })}
              </div>
            </div>
          );
        })}
        {props.category.title === 'MID LAYERS' && (
          <div className="card-performance">
            <div className="card-performance-title">
              <h1>PERFOR</h1>
              <h1 className="mance">MANCE</h1>
            </div>
            <div className="card-performance-text">
              <p>
                Performance is not just a goal — it is a commitment to
                excellence.
              </p>
            </div>
          </div>
        )}
        {props.category.title === 'VEST AND WINDSTOPPER' && (
          <div className="card-banner">
            <img
              src="/images/essentials/marc_vest.jpg"
              alt=""
              className="banner_essentials"
            />
          </div>
        )}
      </div>
    </section>
  );
};
